module.exports = __webpack_public_path__ + "img/ic-store.146b2932.svg";